import { render, staticRenderFns } from "./CoverImage.vue?vue&type=template&id=b2196db6&"
import script from "./CoverImage.vue?vue&type=script&lang=js&"
export * from "./CoverImage.vue?vue&type=script&lang=js&"
import style0 from "./CoverImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2196db6')) {
      api.createRecord('b2196db6', component.options)
    } else {
      api.reload('b2196db6', component.options)
    }
    module.hot.accept("./CoverImage.vue?vue&type=template&id=b2196db6&", function () {
      api.rerender('b2196db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/search/components/CoverImage.vue"
export default component.exports